<template>
<div v-if="widgetOptions && !widgetOptions.disableWidgetView">
  <div v-if='isActive' class="static-gs gs-sm-2 trend-metrics-tab-panel" ref="trendMetricsTabPanel">
     <div class="tab-content">
       <div v-html="data.metric.paragraphics"></div>
       <div v-if="!widgetOptions">
          <br v-if="data.metric.sub_paragraphics"/>
          <div v-if="data.metric.sub_paragraphics" v-html="data.metric.sub_paragraphics"></div>
       </div>
     </div>
     <div class="chart-container">
       <marketTrendsChart :filterType="filterType" :widgetOptions="widgetOptions" :metricDetail="getMetric"></marketTrendsChart>
     </div>
  </div>
</div>

<div v-else>
	<div v-if='isActive' class="trend-metrics-tab-panel" ref="trendMetricsTabPanel">
     <div class="tab-content tab-content-panel">
      <div class="trend-selection">
          <marketTrendsDropdown :options="marketTrendTypes" :selectedItem="selectedMarketTrend" @changed="updateSelectedMarketTrend"></marketTrendsDropdown>
      </div>
       <marketTrendsTabHeader v-if="hasOneMonthData" :tabHeader="getMetric"></marketTrendsTabHeader>
     </div>
     <div class="chart-container-market">
       <marketTrendsChart :filterType="filterType" :widgetOptions="widgetOptions" :metricDetail="getMetric" :selectedTimePeriod="'L2Y'"></marketTrendsChart>
     </div>
  </div>
</div>
</template>

<script src="./markettrends-tab.js"></script>
<style lang="css">
@use './markettrends-tab.scss' as *;
</style>